import React, { useEffect, useState } from "react";
import "../style/maincompstyle/sidebar.scss";
import { NavLink } from "react-router-dom";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import { useSelector, useDispatch } from "react-redux";
import {
  sidenav,
  productorderid,
  productorder,
} from "../redux/reducer/counterslice";
import { sidebar, dvtabs } from "../redux/reducer/counterslice";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import $ from "jquery";
import SickIcon from "@mui/icons-material/Sick";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import TroubleshootIcon from "@mui/icons-material/Troubleshoot";
import ReportIcon from "@mui/icons-material/Report";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import DescriptionIcon from "@mui/icons-material/Description";
function SideBar() {
  var list = [];
  var list2 = [];
  var list3 = [];
  var list4 = [];
  var list5 = [];

  const sideactive = useSelector(state => state.counter.sidebarnav);
  const sidebarmenustate = useDispatch();
  const sidebarstate = useSelector(state => state.counter.sidebar);
  const [expand, setexpand] = useState();
  const sidebaractive = useDispatch();
  const tabsstate = useDispatch();
  const dispatch = useDispatch();
  const dispatchid = useDispatch();
  // console.log(sidebarstate);
  let roledata = localStorage.getItem("role");
  let access_user = useSelector(state => state.counter.admin_access);
  console.log(access_user, "access_user");
  console.log(access_user, "accesss");
  // console.log(roledata);
  // console.log(expand);
  $(window).resize(function () {
    // console.log(
    //   window.innerWidth
    //   )
    if (window.innerWidth <= 920) {
      sidebaractive(sidenav(false));
    }
  });
  console.log(sidebarstate, "sidebarstate");
  const navData = [
    access_user?.includes("dashboard") && {
      id: 0,
      icon: <HomeRoundedIcon style={{ padding: "10px", fontSize: "46px" }} />,
      text: "DashBoard",
      class:
        "adminusernav" +
        `${sidebarstate == "DashBoard" ? " activesidemenu" : ""}`,
      link: "/",
    },
    access_user?.includes("financial_dashboard") && {
      id: 16,
      icon: <AttachMoneyIcon style={{ padding: "10px", fontSize: "46px" }} />,
      text: "Financial DashBoard",
      class:
        "adminusernav" +
        `${sidebarstate == "Financial DashBoard" ? " activesidemenu" : ""}`,
      link: "/FinancialDashBoard",
    },
    access_user?.includes("appointment_main") && {
      id: 9,
      icon: (
        <i
          class="fas fa-book"
          style={{ padding: "13px", fontSize: "17px" }}
        ></i>
      ),
      text: "Appointment",
      subMenus: [
        access_user?.includes("appointment_details") && {
          name: "Appointments Details",
          link: "/AppoinmentDetails",
          icon: (
            <i
              class="fas fa-address-card"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Appointments Details",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Appointments Details" ? " activesidemenu" : ""
            }`,
        },
        access_user?.includes("appoin_reschedule") && {
          name: "sym",
          link: "/Appoinments",
          icon: (
            // <SickIcon style={{ padding: "10px", fontSize: "46px" }} />
            <i
              class="fas fa-history"
              style={{ padding: "15px", fontSize: "17px" }}
            ></i>
          ),
          text: "Appointments Reschedule",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Appointments Reschedule" ? " activesidemenu" : ""
            }`,
        },
        access_user?.includes("patient_appoin_reschedule") && {
          name: "Patient Appointment Cancel Request",
          link: "/PatientAppoinments",
          icon: (
            // <SickIcon style={{ padding: "10px", fontSize: "46px" }} />
            <i
              class="fas fa-history"
              style={{ padding: "15px", fontSize: "17px" }}
            ></i>
          ),
          text: "Patient Appointment Cancel Request",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Patient Appointment Cancel Request"
                ? " activesidemenu"
                : ""
            }`,
        },
      ],
    },
    access_user?.includes("diagnostics_main") && {
      id: 5,
      icon: (
        <i
          class="fas fa-file-medical-alt"
          style={{ padding: "13px", fontSize: "17px" }}
        ></i>
      ),
      text: "Diagnostics",
      subMenus: [
        access_user?.includes("diagnostics_order") && {
          name: "Diagnosticsorder",
          link: "/Diagnosticsorder",
          icon: (
            <ProductionQuantityLimitsIcon
              style={{ padding: "10px", fontSize: "46px" }}
            />
          ),
          text: "Diagnostics Order",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Diagnostics Order" ? " activesidemenu" : ""}`,
        },

        access_user?.includes("diag_issue") && {
          name: "Issue Report",
          link: "/DiagnosticsIssueReport",
          icon: (
            <i
              class="fas fa-comment-medical"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Diagnostics Issue",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Diagnostics Issue" ? " activesidemenu" : ""}`,
        },

        access_user?.includes("diagn_details") && {
          name: "Diagnostics Details",
          link: "/DiagnosticsRecords",
          icon: (
            <i
              class="fas fa-address-card"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Diagnostics Records",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Diagnostics Records" ? " activesidemenu" : ""}`,
        },

        access_user?.includes("diagnostics_cancel_request") && {
          name: "Diagnostics Cancel Request",
          link: "/DiagnosticsAppoinments",
          icon: (
            <i
              class="fas fa-address-card"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Diagnostics Cancel Request",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Diagnostics Cancel Request"
                ? " activesidemenu"
                : ""
            }`,
        },
      ],
    },
    access_user?.includes("pharma_main") && {
      id: 13,
      icon: <LocalPharmacyIcon style={{ padding: "10px", fontSize: "46px" }} />,
      text: "Pharmacy",
      subMenus: [
        access_user?.includes("pharmacy_request") && {
          name: "img",
          link: "/PharmacyRequest",
          icon: (
            <AddPhotoAlternateIcon
              style={{ padding: "10px", fontSize: "46px" }}
            />
          ),
          text: "Pharmacy Request",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Pharmacy Request" ? " activesidemenu" : ""}`,
        },
        access_user?.includes("product_order") && {
          name: "Productsorder",
          link: "/Productsordernew",
          icon: (
            <ProductionQuantityLimitsIcon
              style={{ padding: "10px", fontSize: "46px" }}
            />
          ),
          text: "Products Order new",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Products Order new" ? " activesidemenu" : ""}`,
        },
        access_user?.includes("pharma_issue") && {
          name: "PharmacyIssue",
          link: "/PharmacyIssue",
          icon: (
            <i
              class="fas fa-comment-medical"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Pharmacy Issue",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Pharmacy Issue" ? " activesidemenu" : ""}`,
        },
        access_user?.includes("pharmacy_details") && {
          name: "Pharmacy Details",
          link: "/PharmacyDetails",
          icon: (
            <i
              class="fas fa-address-card"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Pharmacy Records",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Pharmacy Records" ? " activesidemenu" : ""}`,
        },
        access_user?.includes("precription_request") && {
          name: "Request via Prescription",
          link: "/prescriptionrequest",
          icon: (
            <i
              class="fas fa-address-card"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Request via Prescription",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Request via Prescription"
                ? " activesidemenu"
                : ""
            }`,
        },

        access_user?.includes("pharmacy_cancel_request") && {
          name: "Pharmacy Cancel Requests",
          link: "/PharmacyAppoinments",
          icon: (
            <i
              class="fas fa-address-card"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Pharmacy Cancel Requests",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Pharmacy Cancel Requests"
                ? " activesidemenu"
                : ""
            }`,
        },
      ],
    },
    access_user?.includes("bill_payments") && {
      id: 13,
      icon: <DescriptionIcon style={{ padding: "10px", fontSize: "46px" }} />,
      text: "Bill Payments",
      subMenus: [
        access_user?.includes("appointment_details") && {
          name: "Billing Appointments list",
          link: "/AppoinmentDetails",
          icon: (
            <i
              class="fas fa-address-card"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Billing Appointments list",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Billing Appointments list"
                ? " activesidemenu"
                : ""
            }`,
        },
        access_user?.includes("diagn_details") && {
          name: "Billing Diagnostics Order",
          link: "/DiagnosticsDetails",
          icon: (
            <i
              class="fas fa-address-card"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Billing Diagnostics Order",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Billing Diagnostics Order"
                ? " activesidemenu"
                : ""
            }`,
        },
        access_user?.includes("pharmacy_details") && {
          name: "Pharmacy Details",
          link: "/PharmacyDetails",
          icon: (
            <i
              class="fas fa-address-card"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Billing Pharmacy Order",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Billing Pharmacy Order" ? " activesidemenu" : ""
            }`,
        },
        access_user?.includes("ip_bill_payments") && {
          id: 6,
          icon: (
            <CreditCardIcon style={{ padding: "10px", fontSize: "46px" }} />
          ),
          text: "Billing QR Payment - IP",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Billing QR Payment - IP" ? " activesidemenu" : ""
            }`,
          link: "/BillPayments",
        },
        access_user?.includes("pharma_op_bill") && {
          name: "Pharmacybill",
          link: "/Pharmacybill",
          icon: (
            <i
              class="fas fa-money-check"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Billing QR Payment - Pharmacy",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Billing QR Payment - Pharmacy"
                ? " activesidemenu"
                : ""
            }`,
        },
        access_user?.includes("diag_op_bill") && {
          name: "Diagnosticsbill",
          link: "/Diagnosticsbill",
          icon: (
            <i
              class="fas fa-money-check"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Billing QR Payment - OP",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Billing QR Payment - OP" ? " activesidemenu" : ""
            }`,
        },

        access_user?.includes("ip_bill_payments_cancel") && {
          id: 6,
          icon: (
            <CreditCardIcon style={{ padding: "10px", fontSize: "46px" }} />
          ),
          text: "Billing QR Payment - IP Cancel Request",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Billing QR Payment - IP Cancel Request"
                ? " activesidemenu"
                : ""
            }`,
          link: "/BillPaymentsCancelRequest",
        },
        access_user?.includes("pharma_op_bill_cancel") && {
          name: "Pharmacybill",
          link: "/PharmacybillCancelRequest",
          icon: (
            <i
              class="fas fa-money-check"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Billing QR Payment - Pharmacy Cancel Request",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Billing QR Payment - Pharmacy Cancel Request"
                ? " activesidemenu"
                : ""
            }`,
        },
        access_user?.includes("diag_op_bill_cancel") && {
          name: "Diagnosticsbill",
          link: "/DiagnosticsbillCancelRequest",
          icon: (
            <i
              class="fas fa-money-check"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Billing QR Payment - OP Cancel Request",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Billing QR Payment - OP Cancel Request"
                ? " activesidemenu"
                : ""
            }`,
        },
      ],
    },
    access_user?.includes("cashback_points") && {
      id: 8,
      icon: (
        // <NotificationsActiveIcon
        //   style={{ padding: "10px", fontSize: "46px" }}
        // />
        <i
          class="fas fa-gift"
          style={{ padding: "13px", fontSize: "17px" }}
        ></i>
      ),
      text: "Cash Back Points",
      class:
        "doctorsidebar" +
        `${sidebarstate == "Cash Back Points" ? " activesidemenu" : ""}`,
      link: "/CashBackPoints",
    },
    // !access_user?.includes("cashback_points2") && {
    //   id: 8,
    //   icon: (
    //     // <NotificationsActiveIcon
    //     //   style={{ padding: "10px", fontSize: "46px" }}
    //     // />
    //     <i
    //       class="fas fa-gift"
    //       style={{ padding: "13px", fontSize: "17px" }}
    //     ></i>
    //   ),
    //   text: "Cash Back Points2",
    //   class:
    //     "doctorsidebar" +
    //     `${sidebarstate == "Cash Back Points2" ? " activesidemenu" : ""}`,
    //   link: "/CashBackPoints2",
    // },

    access_user?.includes("kranium_billing_list") && {
      id: 10,
      icon: (
        // <NotificationsActiveIcon
        //   style={{ padding: "10px", fontSize: "46px" }}
        // />
        <i
          class="far fa-chart-bar"
          style={{ padding: "13px", fontSize: "17px" }}
        ></i>
      ),
      text: "Kranium Billing List",
      class:
        "doctorsidebar" +
        `${sidebarstate == "Kranium Billing List" ? " activesidemenu" : ""}`,
      link: "/kraniumBillingList",
    },
    // access_user?.includes("ip_bill_payments") && {
    //   id: 6,
    //   icon: <CreditCardIcon style={{ padding: "10px", fontSize: "46px" }} />,
    //   text: "Bill Payments",
    //   class:
    //     "doctorsidebar" +
    //     `${sidebarstate == "Bill Payments" ? " activesidemenu" : ""}`,
    //   link: "/BillPayments",
    // },
    access_user?.includes("send_notifications") && {
      id: 7,
      icon: (
        <NotificationsActiveIcon
          style={{ padding: "10px", fontSize: "46px" }}
        />
      ),
      text: "Send Notification",
      class:
        "doctorsidebar" +
        `${sidebarstate == "Send Notification" ? " activesidemenu" : ""}`,
      link: "/SendNotification",
    },
    access_user?.includes("promotions_main") && {
      id: 5,
      icon: (
        <i
          class="fas fa-file-medical-alt"
          style={{ padding: "13px", fontSize: "17px" }}
        ></i>
      ),
      text: "Promotions",
      subMenus: [
        access_user?.includes("patient_testimonials") && {
          id: 11,
          icon: (
            // <NotificationsActiveIcon
            //   style={{ padding: "10px", fontSize: "46px" }}
            // />
            <i
              class="fas fa-file-image"
              style={{ padding: "15px", fontSize: "17px" }}
            ></i>
          ),
          text: "Patient Testimonials",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Patient Testimonials" ? " activesidemenu" : ""
            }`,
          link: "/Patienttestimonials",
        },
        access_user?.includes("best_offers_dash") && {
          name: "img",
          link: "/Banner",
          icon: (
            <AddPhotoAlternateIcon
              style={{ padding: "10px", fontSize: "46px" }}
            />
          ),
          text: "Banner Images",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Banner Images" ? " activesidemenu" : ""}`,
        },
        access_user?.includes("img_and_video") && {
          name: "img",
          link: "/BannerVideo",
          icon: (
            <AddPhotoAlternateIcon
              style={{ padding: "10px", fontSize: "46px" }}
            />
          ),
          text: "Banner Videos",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Banner Videos" ? " activesidemenu" : ""}`,
        },
        {
          name: "img",
          link: "/DashboardBanner",
          icon: (
            <AddPhotoAlternateIcon
              style={{ padding: "10px", fontSize: "46px" }}
            />
          ),
          text: "Dashboard Banner",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Dashboard Banner" ? " activesidemenu" : ""}`,
        },
      ],
    },
    access_user?.includes("doctors_list") && {
      id: 2,
      icon: (
        // <PersonAddAltRoundedIcon
        //   style={{ padding: "10px", fontSize: "46px" }}
        // />
        <i
          class="fa fa-user-md"
          style={{ padding: "13px", fontSize: "17px" }}
        ></i>
      ),
      text: "Doctors List",
      class:
        "doctorsidebar" +
        `${sidebarstate == "Doctors List" ? " activesidemenu" : ""}`,
      link: "/Doctor",
    },
    access_user?.includes("patient_list") && {
      id: 3,
      icon: <PersonRoundedIcon style={{ padding: "10px", fontSize: "46px" }} />,
      text: "Patient List",
      class:
        "doctorsidebar" +
        `${sidebarstate == "Patient List" ? " activesidemenu" : ""}`,
      link: "/Patient",
    },
    access_user?.includes("admin_user") && {
      id: 1,
      icon: (
        <AccountCircleRoundedIcon
          style={{ padding: "10px", fontSize: "46px" }}
        />
      ),
      text: "Admin User",
      class:
        "adminusernav" +
        `${sidebarstate == "Admin User" ? " activesidemenu" : ""}`,
      link: "/AdminUser",
    },
    access_user?.includes("admin_access") && {
      id: 15,
      icon: (
        <AccountCircleRoundedIcon
          style={{ padding: "10px", fontSize: "46px" }}
        />
      ),
      text: "Admin User Rights List",
      class:
        "adminusernav" +
        `${sidebarstate == "Admin User Rights List" ? " activesidemenu" : ""}`,
      link: "/AdminAccess",
    },
    access_user?.includes("speciality") && {
      name: "spa",
      link: "/Speciality",
      icon: (
        <i
          class="fa fa-stethoscope"
          style={{ padding: "13px", fontSize: "17px" }}
        ></i>
      ),
      text: "Speciality",
      class:
        "doctorsidebar" +
        `${sidebarstate == "Speciality" ? " activesidemenu" : ""}`,
    },
    access_user?.includes("symptoms") && {
      name: "sym",
      link: "/Symptoms",
      icon: <SickIcon style={{ padding: "10px", fontSize: "46px" }} />,
      text: "Symptoms",
      class:
        "doctorsidebar" +
        `${sidebarstate == "Symptoms" ? " activesidemenu" : ""}`,
    },
    {
      name: "ret",
      link: "/returnedCashback",
      icon: <DescriptionIcon style={{ padding: "10px", fontSize: "46px" }} />,
      text: "Revised Cashback",
      class:
        "doctorsidebar" +
        `${sidebarstate == "Revised Cashback" ? " activesidemenu" : ""}`,
    },
    access_user?.includes("diagnostics_master") && {
      id: 5,
      icon: (
        <i
          class="fas fa-file-medical-alt"
          style={{ padding: "13px", fontSize: "17px" }}
        ></i>
      ),
      text: "Diagnostics Master",
      subMenus: [
        access_user?.includes("investigations") && {
          name: "Invest",
          link: "/Investigations",
          icon: (
            <i
              class="fas fa-book-medical"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Investigations Master",
          class:
            "doctorsidebar" +
            `${
              sidebarstate == "Investigations Master" ? " activesidemenu" : ""
            }`,
        },
        access_user?.includes("packages") && {
          name: "Pack",
          link: "/Packages",
          icon: (
            <i
              class="fas fa-pills"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Packages Master",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Packages Master" ? " activesidemenu" : ""}`,
        },
        access_user?.includes("diag_banner") && {
          name: "DiagnosticsBanner",
          link: "/DiagnosticsBanner",
          icon: (
            <i
              class="far fa-images"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Diagnostics Banner",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Diagnostics Banner" ? " activesidemenu" : ""}`,
        },
        access_user?.includes("issue_list") && {
          name: "IssueList",
          link: "/IssueList",
          icon: (
            <i
              class="fas fa-address-card"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Issue Types List",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Issue Types List" ? " activesidemenu" : ""}`,
        },
      ],
    },
    access_user?.includes("pharma_master") && {
      id: 14,
      icon: <LocalPharmacyIcon style={{ padding: "10px", fontSize: "46px" }} />,
      text: "Pharmacy Master",
      subMenus: [
        access_user?.includes("pharma_products") && {
          name: "Online pharmacy",
          link: "/PharmacyNew",
          icon: <VaccinesIcon style={{ padding: "10px", fontSize: "46px" }} />,
          text: "Online pharmacy",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Online pharmacy" ? " activesidemenu" : ""}`,
        },
        access_user?.includes("medicine_type") && {
          name: "Medicine Type",
          link: "/MedicineType",
          icon: <VaccinesIcon style={{ padding: "10px", fontSize: "46px" }} />,
          text: "Medicine Type",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Medicine Type" ? " activesidemenu" : ""}`,
        },
        access_user?.includes("pharma_banner_vid") && {
          name: "img",
          link: "/PharmacyBannerVideo",
          icon: (
            <AddPhotoAlternateIcon
              style={{ padding: "10px", fontSize: "46px" }}
            />
          ),
          text: "PharmacyBanner",
          class:
            "doctorsidebar" +
            `${sidebarstate == "PharmacyBanner" ? " activesidemenu" : ""}`,
        },
        access_user?.includes("issue_list") && {
          name: "IssueList",
          link: "/IssueList",
          icon: (
            <i
              class="fas fa-address-card"
              style={{ padding: "13px", fontSize: "17px" }}
            ></i>
          ),
          text: "Issue Type List",
          class:
            "doctorsidebar" +
            `${sidebarstate == "Issue List" ? " activesidemenu" : ""}`,
        },
      ],
    },

    // old
  ];

  const sidebarhandleclick = e => {
    if (e != "Settings" && e != "Diagnostics") {
      console.log(e, "here");
      sidebarmenustate(sidebar(e));
    }
    dispatchid(productorderid(""));
    dispatch(productorder(""));

    tabsstate(dvtabs("About"));
  };

  const hoverstate = e => {
    if (!sideactive) {
      $(".sidebarclose").css("width", "240px");
      $(".linkTextclosed").css("display", "block");
      $(".arrow").css("display", "block");
    }

    // try {
    //   console.log(navData, "jhegfjah");
    //   // navData[11] != undefined &&
    //   //   navData[11] != "" &&
    //   //   navData[11].subMenus.map((e) => {
    //   //     list.push(e.text);
    //   //   });
    //   navData[9] != undefined &&
    //     navData[9] != "" &&
    //     navData[9] != false &&
    //     navData[9].subMenus.map((e) => {
    //       list2.push(e.text);
    //     });
    //   navData[5] != undefined &&
    //     navData[5] != "" &&
    //     navData[5].subMenus.map((e) => {
    //       list3.push(e.text);
    //     });
    //   navData[13] != undefined &&
    //     navData[13] != "" &&
    //     navData[13].subMenus.map((e) => {
    //       list4.push(e.text);
    //     });
    //   navData[15] != undefined &&
    //     navData[15] != "" &&
    //     navData[15].subMenus.map((e) => {
    //       list5.push(e.text);
    //     });
    // } catch (err) {
    //   console.log(err, "hover");
    // }

    // // if (list.includes(sidebarstate)) {
    // //   setexpand(11);
    // // } else
    // if (list2.includes(sidebarstate)) {
    //   setexpand(9);
    // } else if (list3.includes(sidebarstate)) {
    //   setexpand(5);
    // } else if (list4.includes(sidebarstate)) {
    //   setexpand(13);
    // } else if (list5.includes(sidebarstate)) {
    //   setexpand(15);
    // }
  };
  const hoverleave = e => {
    if (!sideactive) {
      $(".sidebarclose").css("width", "65px");
      $(".linkTextclosed").css("display", "none");
      setexpand(false);
      $(".arrow").css("display", "none");
    }
  };
  useEffect(() => {
    if (!sideactive) {
      setexpand(false);
    }
  }, [sideactive]);

  // useEffect(() => {
  //   if (sideactive) {
  //     try {
  //       console.log(navData);
  //       // navData[11] != undefined &&
  //       //   navData[11] != "" &&
  //       //   navData[11].subMenus.map((e) => {
  //       //     list.push(e.text);
  //       //   });
  //       navData[9] != undefined &&
  //         navData[9] != "" &&
  //         navData[9] != false &&
  //         navData[9].subMenus.map((e) => {
  //           list2.push(e.text);
  //         });
  //       navData[5] != undefined &&
  //         navData[5] != "" &&
  //         navData[5].subMenus.map((e) => {
  //           list3.push(e.text);
  //         });
  //       navData[13] != undefined &&
  //         navData[13] != "" &&
  //         navData[13].subMenus.map((e) => {
  //           list4.push(e.text);
  //         });
  //       navData[15] != undefined &&
  //         navData[15] != "" &&
  //         navData[15].subMenus.map((e) => {
  //           list5.push(e.text);
  //         });
  //     } catch (err) {
  //       console.log(err, "test");
  //     }
  //     try {
  //       // if (list.includes(sidebarstate)) {
  //       //   setexpand(11);
  //       // } else

  //       if (list2.includes(sidebarstate)) {
  //         setexpand(9);
  //       } else if (list3.includes(sidebarstate)) {
  //         setexpand(5);
  //       } else if (list4.includes(sidebarstate)) {
  //         setexpand(13);
  //       } else if (list5.includes(sidebarstate)) {
  //         setexpand(15);
  //       }
  //     } catch (err) {
  //       console.log(err, "test");
  //     }
  //   }
  // }, [sideactive]);

  const expandfunc = (e, index) => {
    console.log(index, expand);
    if (index == expand) {
      setexpand(null);
    } else {
      setexpand(index);
    }
  };

  return (
    <>
      <div
        className={sideactive ? "sidebar" : "sidebarclose"}
        id="sidebar"
        onMouseEnter={e => hoverstate(e)}
        onMouseLeave={e => hoverleave(e)}
      >
        <div className="sidebar-inner slimscroll">
          <div id="sidebar-menu" className="sidebar-menu">
            <ul className="sidebar_content">
              {navData.map((item, index) => {
                // console.log(item);
                if (item?.icon) {
                  return (
                    <>
                      <NavLink
                        to={item.link}
                        style={{ textDecoration: "none" }}
                      >
                        <li
                          key={item.id}
                          className={`sideitem row ${item.class}`}
                          href={item.link}
                          onClick={e => {
                            sidebarhandleclick(item.text);
                            if (item.subMenus) {
                              expandfunc(e, index);
                            }
                          }}
                        >
                          <div href={item.link} className="col-2">
                            {item.icon}
                          </div>
                          <div
                            className={
                              sideactive
                                ? "linkText col-6"
                                : "linkTextclosed col-6"
                            }
                            style={{ display: sideactive ? "block" : "" }}
                          >
                            <NavLink className="nav-link" to={item.link}>
                              {item.text}
                            </NavLink>
                          </div>
                          {item.subMenus ? (
                            <>
                              <i
                                class={
                                  "bi bi-caret-right-fill arrow col-2" +
                                  `${expand == index ? " arrowexpand" : ""}`
                                }
                                style={{
                                  display: sideactive ? "block" : "none",
                                  marginLeft: "30px",
                                }}
                                onClick={e => {
                                  expandfunc(e, index);
                                }}
                              ></i>
                            </>
                          ) : (
                            ""
                          )}
                        </li>
                      </NavLink>
                      <ul
                        className={`sub-menu ${index} ${
                          expand == index ? " activeside" : ""
                        } `}
                      >
                        {item.subMenus != undefined &&
                          item.subMenus?.map(ele => {
                            if (ele.link) {
                              return (
                                <NavLink
                                  to={ele.link}
                                  style={{ textDecoration: "none" }}
                                  // className={`${
                                  //   expand == index ? " activeside1" : ""
                                  // }`}
                                >
                                  <li
                                    key={ele.id}
                                    className={`sideitem row ${ele.class}`}
                                    href={ele.link}
                                    onClick={e => sidebarhandleclick(ele.text)}
                                  >
                                    <div href={ele.link} className="col-2">
                                      {ele.icon}
                                    </div>
                                    <span
                                      className={
                                        sideactive
                                          ? "linkText col-6"
                                          : "linkTextclosed col-6"
                                      }
                                      style={{
                                        display: sideactive ? "block" : "",
                                      }}
                                    >
                                      <NavLink
                                        className="nav-link"
                                        to={ele.link}
                                        style={{ textDecoration: "none" }}
                                      >
                                        {ele.text}
                                      </NavLink>
                                    </span>
                                  </li>
                                </NavLink>
                              );
                            }
                          })}
                      </ul>
                    </>
                  );
                }
              })}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default SideBar;
